"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = exports.palette = void 0;

var _styles = require("@mui/material/styles");

var palette = {
  common: {
    white: '#fff',
    black: '#000'
  },
  primary: {
    main: '#33447c',
    dark: '#283663',
    light: '#5c6996',
    superLight: '#d6dae5'
  },
  secondary: {
    main: '#f4d138',
    dark: '#c3a72c',
    light: '#fdf6d7'
  },
  text: {
    primary: '#4a4a4a',
    secondary: '#4a4a4a',
    disabled: '#dddddd'
  },
  divider: '#dddddd',
  dividerLight: '#eceae7',
  dividerGray: '#f0f0f0',
  dividerBlue: '#66729c',
  error: {
    main: '#d03243',
    dark: '#a62835',
    light: '#da5b69'
  },
  link: {
    main: '#029cef',
    dark: '#017cbf',
    light: '#35b0f2'
  },
  grey: {
    main: '#9b9b9b',
    dusty: '#979797',
    light: '#e7f4f3',
    superLight: '#dcdcdc',
    medium: '#d7d7d7',
    dark: '#f3f1ee',
    regular: '#c0c0c0',
    timberWolf: '#dad5cf',
    timberWolfDark: '#aeaaa5',
    chambray50: '#99a1bd',
    lighten: '#f5f8fa',
    mediumLight: '#e5e5e5'
  },
  teal: {
    main: '#0cbeb8',
    medium: '#e6f8f7',
    lighten: '#f2fafe',
    light: '#85dedb'
  },
  green: {
    main: '#6fd78a',
    superLight: '#b3ddd9',
    light: '#f0fbf3',
    dark: '#15998c',
    superDark: '#0f655d',
    fruitSalad: '#4a974a',
    fruitSalad120: '#3b783b',
    fruitSalad80: '#6eac6e',
    fruitSalad20: '#dbeadb',
    fruitSaladLight: '#ecf4ec',
    mountainMeadowDark: '#107a70',
    mountainMeadowLight: '#44ada3',
    mountainMeadow50: '#8accc5',
    mountainMeadow100: '#15998C'
  },
  yellow: {
    sunflower: '#f4d138',
    sunflower50: '#fae89a',
    sunflowerSuperLight: '#fdfaeb'
  },
  red: {
    main: '#d03243',
    light: '#e798a1',
    superLight: '#f6d6d9',
    brickRed10: '#fceff0'
  },
  background: {
    "default": '#f9f9f9',
    grey: '#faf9f7',
    darken: '#f6f6f6'
  },
  additional: {
    orange50: '#f0bf9e',
    red80: '#da5b69',
    blue10: '#e5f5fd',
    googleBlue: '#4285f4',
    msDark: '#2f2f2f',
    chambray10: '#eaecf1',
    chambray05: '#f7f9fe',
    chambray20: '#9ea9c6'
  },
  orange: {
    main: '#e1813d',
    light: '#e79a64',
    superLight: '#fcf4ed',
    dark: '#ff9300'
  },
  brown: {
    main: '#545454',
    secondary: '#5e5e5e'
  },
  border: {
    grey: '#e8e8e8'
  },
  closeIcon: '#d8d8d8'
};
exports.palette = palette;
var theme = (0, _styles.createTheme)({
  shape: {
    borderRadius: 5
  },
  background: {
    "default": '#f6f6f6'
  },
  typography: {
    fontFamily: 'Lato, Roboto, Helvetica, Arial, sans-serif',
    h1: {
      fontSize: '3rem',
      lineHeight: '3.5rem',
      fontWeight: 700,
      color: palette.primary.main
    },
    h2: {
      fontSize: '2rem',
      lineHeight: '2.5rem',
      fontWeight: 300
    },
    h3: {
      fontSize: '1.5rem',
      lineHeight: '2rem',
      fontWeight: 400
    },
    h4: {
      fontSize: '1.25rem',
      lineHeight: '1.5rem',
      fontWeight: 400
    },
    subtitle2: {
      color: palette.grey.main,
      fontSize: '1rem',
      fontWeight: 400
    }
  },
  palette: palette,
  components: {
    MuiTypography: {
      styleOverrides: {
        root: {
          display: 'block'
        }
      }
    },
    MuiMenuItem: {
      styleOverrides: {
        root: {
          fontWeight: 'bold',
          color: palette.link.main
        }
      }
    },
    MuiAvatar: {
      styleOverrides: {
        root: {
          width: '30px',
          height: '30px',
          boxShadow: '0 2px 2px rgba(0, 0, 0, 0.1)'
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          height: '48px'
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          borderBottomColor: palette.text.disabled
        },
        head: {
          fontWeight: 'bold',
          textTransform: 'uppercase',
          color: palette.grey.main
        },
        body: {
          fontSize: '1rem'
        }
      }
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          height: '80px'
        }
      }
    },
    MuiAppBar: {
      styleOverrides: {
        colorSecondary: {
          backgroundColor: palette.common.white
        },
        colorPrimary: {
          color: palette.common.white
        }
      }
    },
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: palette.background.darken
        }
      }
    },
    MuiTab: {
      styleOverrides: {
        root: {
          height: '80px',
          minWidth: '100px',
          lineHeight: 1.15,
          textTransform: 'none',
          fontWeight: 'bold',
          fontSize: '1rem',
          flexDirection: 'row',
          alignItems: 'auto',
          '@media (min-width: 600px)': {
            minWidth: '160px'
          }
        },
        textColorInherit: {
          opacity: 1
        }
      }
    },
    MuiListItem: {
      styleOverrides: {
        root: {
          paddingTop: 8,
          paddingBottom: 8
        },
        dense: {
          paddingTop: 4,
          paddingBottom: 4
        }
      }
    },
    MuiPrivateTabIndicator: {
      styleOverrides: {
        root: {
          height: '4px'
        }
      }
    },
    MuiInputLabel: {
      styleOverrides: {
        outlined: {
          lineHeight: '1.1375em'
        }
      }
    },
    MuiOutlinedInput: {
      styleOverrides: {
        input: {
          padding: '12.5px 14px'
        },
        inputMultiline: {
          padding: 0
        },
        inputAdornedStart: {
          paddingLeft: 0
        },
        root: {
          '&.Mui-focused': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderWidth: 1
            }
          },
          '&:hover:not(.Mui-disabled):not(.Mui-error)': {
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: palette.primary.main
            }
          }
        },
        '&:not(.MuiInputLabel-shrink):not(.Mui-error):not(.Mui-disabled)': {
          color: palette.grey.main
        }
      }
    },
    MuiButton: {
      styleOverrides: {
        root: {
          fontSize: '1rem',
          padding: '12px 24px',
          textTransform: 'none'
        },
        sizeSmall: {
          padding: '4px 10px'
        },
        text: {
          padding: '6px 8px'
        },
        label: {
          textTransform: 'none'
        },
        outlined: {
          padding: '5px 15px',
          border: "1px solid ".concat(palette.divider),
          '&:hover': {
            backgroundColor: palette.grey.A200,
            border: "1px solid ".concat(palette.grey.regular)
          }
        },
        containedSecondary: {
          color: palette.primary.main
        }
      }
    },
    MuiInputBase: {
      styleOverrides: {
        root: {
          color: palette.text.primary,
          '&.Mui-disabled': {
            color: palette.grey.main,
            backgroundColor: palette.background.darken,
            borderColor: palette.divider,
            '& input': {
              WebkitTextFillColor: palette.grey.main
            }
          }
        }
      }
    },
    MuiLink: {
      styleOverrides: {
        root: {
          color: palette.link.main,
          textDecoration: 'none'
        }
      }
    },
    MuiFormLabel: {
      styleOverrides: {
        root: {
          color: palette.text.primary,
          '&.Mui-disabled': {
            color: palette.text.primary
          }
        }
      }
    },
    MuiIcon: {
      styleOverrides: {
        root: {
          color: palette.grey.main,
          fontSize: '1.25rem'
        }
      }
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          background: palette.common.white
        }
      }
    },
    MuiPaper: {
      styleOverrides: {
        elevation1: {
          boxShadow: '0 2px 2px rgba(0, 0, 0, 0.1)'
        }
      }
    },
    MuiFormHelperText: {
      styleOverrides: {
        contained: {
          marginTop: 8,
          marginLeft: 14,
          marginRight: 14
        }
      }
    }
  }
});
exports.theme = theme;